import { ViewModel, View, ObservableArray } from "binder"
import { ProducerManipulationView } from "./producerManipulation-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { ProducerEditorViewModel, ProducerInserter, ProducerUpdater } from "./producerEditor/producerEditor-viewModel";
import { IProducer } from "./IProducer";

export class ProducerManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف سازنده';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.producers = ObservableArray.create<Producer>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new ProducerManipulationView();
    }
    public getTypeId(): string {
        return "VM-8028F60B-951C-4E7C-A32E-6A70C1B419C8"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set producers(v: ObservableArray<Producer>) { this._producers = v; } public get producers(): ObservableArray<Producer> { return this._producers; } private _producers: ObservableArray<Producer>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ProducerServices/ListAllProducers', {
                FilteringInformation: filteringInformation
            });
            this.producers.update(...result.Producers.map((x, i) => {
                let p = new Producer(this);
                p.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                p.id = x.Id;
                p.name = x.Name;
                p.code = x.Code;
                p.country = x.Country;
                return p;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async addNew() {
        let popup = new ProducerEditorViewModel(this, new ProducerInserter());
        let result = await this.showPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async edit(producer: IProducer) {
        let popup = new ProducerEditorViewModel(this, new ProducerUpdater());
        await producer.cloneTo(popup);
        let result = await this.requestShowingPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async remove(producer: Producer): Promise<void> {
        let isDeleted = await this.messageBoxDangerYesNo('آیا از حذف اطمینان دارید؟', 'حذف');
        if (isDeleted == 'yes') {
            try {
                let result = await ServerConnection.callServer("/Complex/ProducerServices/DeleteProducer", {
                    ProducerId: producer.id,
                });
                if (result.IsSuccessful == true) {
                    await this.messageBoxConfirmSuccess("حذف با موفقیت انجام شد", "عملیات موفق");
                    this.dataLoader.refresh();
                } else {
                    if (result.Faults[0].Parameters.FaultId == 'D2BF392F-0EC9-4491-9DD3-FF7F3E096630') {
                        await this.messageBoxConfirmWarning("امکان حذف وجود ندارد", "خطا در عملیات");
                    }
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning("خطا در عملیات حذف", "خطا در عملیات");
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }
}

export class Producer extends ViewModel implements IProducer {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ProducerManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: ProducerManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set country(v: string) { this._country = v; } public get country(): string { return this._country; } private _country: string;

    async cloneTo(producer: IProducer) {
        producer.id = this.id;
        producer.name = this.name;
        producer.code = this.code;
        producer.country = this.country;
    }

    async edit() {
        this._typedParent.edit(this);
    }

    async remove(): Promise<void> {
        this._typedParent.remove(this);
    }
}
